import React from 'react';
import { WORLD_ENDPOINTS } from '../../../../types/world';
import Header from '../../../uikit/parts/Header';
import Footer from '../../../uikit/parts/Footer';
import useEmotionStyles from '../../../uikit/hooks/useEmotionStyles';
var styles = function () { return ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    part: {
        flex: '0 0 auto',
    },
    content: {
        flex: '1 0 auto',
    },
}); };
export var MainLayout = function (props) {
    var children = props.children, flatHeader = props.flatHeader;
    var cs = useEmotionStyles(styles);
    return (React.createElement("div", { className: cs.wrapper },
        React.createElement("div", { className: cs.part },
            React.createElement(Header, { redirectLink: WORLD_ENDPOINTS.SMAVA_ROOT, isFlat: flatHeader, hidePhone: true })),
        React.createElement("div", { className: cs.content }, children),
        React.createElement("div", { className: cs.part },
            React.createElement(Footer, null))));
};
